import variableColors from "@/base/global/variables/figma.colors.json";
import variableTypography from "@/base/global/variables/figma.typography.json";

export const formThemeToken: any = {
  //=============================== COLORS ===============================//
  labelColor: variableColors["ColorFigmaNeutralGrayscaleGray90"],
  labelRequiredMarkColor: variableColors["ColorFigmaFunctionalAlert50"],
  colorBorder: variableColors["ColorFigmaNeutralGrayscaleGray40"],
  colorError: variableColors["ColorFigmaFunctionalAlert50"],
  colorPrimary: variableColors["ColorFigmaComplementaryBlue50"],
  colorSuccess: variableColors["ColorFigmaFunctionalSuccess50"],
  colorText: variableColors["ColorFigmaNeutralGrayscaleGray90"],
  colorTextDescription: variableColors["ColorFigmaNeutralGrayscaleGray70"],
  colorWarning: variableColors["ColorFigmaFunctionalWarning50"],

  //=============================== TYPOGRAPHY ===============================//
  labelFontSize: variableTypography["BodyLargeFontSize"],
  labelHeight: 32,
  labelFontWeight: variableTypography["BodyH100FontWeight"],
  fontFamily: variableTypography["BodyLargeFontFamily"],
};
